import { Controller } from "stimulus";

export default class extends Controller {
  deleteSelected(event) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) headers["X-CSRF-Token"] = token.getAttribute("content");

    event.preventDefault();
    event.stopPropagation();
    const tableType = event.currentTarget.dataset.table;
    const selectedRows = document.querySelectorAll(
      `.${tableType}-items-table input[name="transaction_item_ids[]"]:checked`
    );

    if (selectedRows.length === 0) {
      alert("No items selected for deletion.");
      return;
    }

    const selectedIds = Array.from(selectedRows).map((input) => input.value);
    fetch(
      `/admin/shipments/${event.currentTarget.dataset.shipment_id}/transaction_items/bulk_delete`,
      {
        method: "delete",
        headers,
        body: JSON.stringify({ transaction_item_ids: selectedIds }),
      }
    ).then((_response) => {
      window.location.reload();
    });
  }
}
